import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { IncidentCard } from "./IncidentCard";
import { CATEGORY_META } from "../constants/content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Gallery = () => {
  const [items, setItems] = useState([]);
  const [cats, setCats] = useState([]);
  const [active, setActive] = useState("all");
  const [sort, setSort] = useState("cringe_desc");

  useEffect(() => {
    axios
      .get(`${API}/incidents/categories`)
      .then((r) => setCats(r.data.categories || []));
  }, []);

  useEffect(() => {
    const q = active === "all" ? "" : `category=${active}&`;
    axios
      .get(`${API}/incidents?${q}sort=${sort}`)
      .then((r) => setItems(r.data))
      .catch((e) => console.error(e));
  }, [active, sort]);

  const tabs = useMemo(() => ["all", ...cats], [cats]);

  return (
    <section id="gallery" className="py-20" data-testid="gallery-section">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <header className="mb-10">
          <span className="font-mono text-xs uppercase text-[#FF00FF]">
            Chapter 03 · The Full Collection
          </span>
          <h2 className="heading text-5xl md:text-7xl leading-[0.9] mt-2">
            BROWSE BY <span className="bg-[#FF00FF] text-black px-2">CATEGORY</span>
          </h2>
        </header>

        {/* Filter bar */}
        <div
          className="brutal-border bg-black p-3 md:p-4 flex flex-wrap items-center gap-3 mb-8"
          style={{ boxShadow: "6px 6px 0 0 #FFEA00" }}
        >
          <div className="flex flex-wrap gap-2 flex-1">
            {tabs.map((c) => {
              const meta = CATEGORY_META[c] || { label: c.toUpperCase(), color: "bg-white text-black" };
              const isActive = active === c;
              return (
                <button
                  key={c}
                  onClick={() => setActive(c)}
                  data-testid={`filter-${c}`}
                  className={`font-mono text-[11px] uppercase font-bold px-3 py-2 brutal-border transition-transform duration-100 ${
                    isActive ? meta.color : "bg-transparent text-white"
                  }`}
                  style={{
                    borderWidth: 3,
                    boxShadow: isActive ? "4px 4px 0 0 #FF003C" : "none",
                    transform: isActive ? "translate(2px, 2px)" : "none",
                  }}
                >
                  {meta.label}
                </button>
              );
            })}
          </div>
          <div className="flex items-center gap-2 ml-auto">
            <span className="font-mono text-[11px] text-white/60 uppercase">
              Sort
            </span>
            <select
              value={sort}
              onChange={(e) => setSort(e.target.value)}
              data-testid="sort-select"
              className="bg-[#FFEA00] text-black font-mono text-xs uppercase px-2 py-2 brutal-border"
              style={{ borderWidth: 3 }}
            >
              <option value="cringe_desc">CRINGE ▼</option>
              <option value="date_desc">DATE ▼</option>
              <option value="reactions_desc">REACTIONS ▼</option>
            </select>
          </div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {items.map((it, i) => (
            <IncidentCard key={it.id} incident={it} index={i} />
          ))}
        </div>
        {items.length === 0 && (
          <div className="font-mono text-white/60 mt-10">
            No incidents in this category. Yet.
          </div>
        )}
      </div>
    </section>
  );
};
